
import { get, post } from 'Api';
import store from 'Redux/store';


// Allow tag manager to Set cookie requested by frontend (for cj event id in safari)
export function setServerSideCookie(name, value, options) {
  return post(store.dispatch, '/cookie/set-cookie', { name, value, options });
}

export async function fetchCookieData() {
  const { response, data } = await get(store.dispatch, '/cookie/data-fetch');
  if (response.ok) {
    return data;
  }

  return {};
}
